import React from 'react'
import PropTypes from 'prop-types'
import Modal from 'component/utils/Modal'
import useScrollShadow from 'utils/hooks/useScrollShadow'

const scrollStyles = `
  .detailed-warning-modal-scrollable-list::-webkit-scrollbar {
    width: 5px;
  }
  .detailed-warning-modal-scrollable-list::-webkit-scrollbar-thumb {
    border-radius: 20px;
    border: 3px solid #d3d2d6;
  }
`;

if (typeof document !== 'undefined' && !document.getElementById('detailed-warning-modal-scroll-styles')) {
  const styleElement = document.createElement('style');
  styleElement.id = 'detailed-warning-modal-scroll-styles';
  styleElement.textContent = scrollStyles;
  document.head.appendChild(styleElement);
}

const DetailedWarningModal = ({
  message,
  messageAsHtml,
  onClose,
  isError, // eslint-disable-line no-unused-vars
  showButton1 = true,
  translate,
  title,
  question,
  button1Text,
  button2Text,
  onButton1Click,
  onButton2Click,
  scrollableList,
  singleButtonCenter = false
}) => {
  const scrollableListRef = useScrollShadow([scrollableList])

  return (
    <Modal
      isOpen={true}
      onCloseModal={onClose}
      showHeader={false}
      showFooter={false}
      center
      size="sm"
      className="pricebanner-warning-modal"
    >
      <div>
        <h2 className="detailed-warning-modal-title">
          {title || (translate && translate('attention'))}
        </h2>
        <div className="detailed-warning-modal-content">
          {messageAsHtml ? (
            <span dangerouslySetInnerHTML={{ __html: messageAsHtml }} />
          ) : (
            message
          )}
          {question && (
            <>
              <br />
              <br />
              {question}
            </>
          )}
        </div>

        {scrollableList && Array.isArray(scrollableList) && scrollableList.length > 0 && (
          <div ref={scrollableListRef} className="detailed-warning-modal-scrollable-list">
            {scrollableList.map((item, index) => (
              <div key={index} className="detailed-warning-modal-list-item">
                {item}
              </div>
            ))}
          </div>
        )}
        <div className={`detailed-warning-modal-buttons ${showButton1 ? 'buttons-right' : 'buttons-centered'} ${singleButtonCenter && !showButton1 ? 'single-button-center' : ''}`}>
          {showButton1 && (
            <button
              onClick={onButton1Click || onClose}
              className="detailed-warning-modal-button-primary"
            >
              {button1Text}
            </button>
          )}
          <button
            onClick={onButton2Click || onClose}
            className="detailed-warning-modal-button-secondary"
          >
            {button2Text || (translate && translate('ok_button')) || 'OK'}
            </button>
        </div>
      </div>
    </Modal>
  )
}

DetailedWarningModal.propTypes = {
  message: PropTypes.string,
  messageAsHtml: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  isError: PropTypes.bool,
  showButton1: PropTypes.bool,
  translate: PropTypes.func,
  title: PropTypes.string,
  question: PropTypes.string,
  button1Text: PropTypes.string,
  button2Text: PropTypes.string,
  onButton1Click: PropTypes.func,
  onButton2Click: PropTypes.func,
  scrollableList: PropTypes.array,
  singleButtonCenter: PropTypes.bool,
}

export default DetailedWarningModal
